import { createStore } from 'vuex'

// const URL = 'http://localhost:5005/';
const URL = 'https://server-web.konaweselatankab.go.id/';
const URL_SIMPEG = 'https://server-egov.konaweselatankab.go.id/';
var UNIT = 'quGckxnzRzEzhncor';

export default createStore({
  state: {
    UNIT_KERJA : UNIT,
    url: {
      URL_APP_SIMPEG: URL_SIMPEG, 
      URL_APP: URL,
      URL_SLIDER: URL + 'api/v1/publish_ukpbj_slider/',
      URL_BERITA: URL + 'api/v1/web_publish_berita/',
      URL_SAMBUTAN: URL + 'api/v1/publish_ukpbj_sambutan/',
      URL_LINK_TERKAIT: URL + 'api/v1/web_publish_link_terkait/',
      URL_FOTO: URL + 'api/v1/publish_ukpbj_foto/',
      URL_DATA_PEGAWAI: URL + 'api/v1/publish_ukpbj_data_pegawai/',
      URL_PRODUK_HUKUM: URL + 'api/v1/publish_ukpbj_produk_hukum/',
      URL_TENTANG_KAMI: URL + 'api/v1/publish_ukpbj_tentang_kami/',
      URL_TUGAS_POKOK: URL + 'api/v1/publish_ukpbj_tupoksi/',
      URL_VISI_MISI: URL + 'api/v1/publish_ukpbj_visi_misi/',
      URL_STRUKTUR_ORGANISASI: URL + 'api/v1/publish_ukpbj_struktur_organisasi/',
      URL_DATA: URL + 'api/v1/publish_ukpbj_data/',
      URL_PARIWISATA: URL + 'api/v1/publish_ukpbj_pariwisata/',
      URL_EKRAF: URL + 'api/v1/publish_ukpbj_ekraf/',
      URL_VIDEO: URL + 'api/v1/publish_ukpbj_video/',
      URL_EVENT: URL + 'api/v1/publish_ukpbj_event/',
      URL_SKM_RUP: 'https://konsel-setara.konaweselatankab.go.id/api/v1/skm/rup',
      // URL_SKM_RUP: 'http://localhost:5025/api/v1/skm/rup',
    },
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
